// Pawdusk: quick-add for the "Complete the walk" row in the cart drawer (event delegation survives re-renders).
import { CartAddEvent } from '@theme/events';

document.addEventListener('click', async (event) => {
  const btn = event.target.closest('.pd-up__add');
  if (!btn) return;
  const item = btn.closest('.pd-up__item');
  const id = item.querySelector('.pd-up__select').value;
  const err = item.querySelector('.pd-up__err');
  if (!id) {
    err.textContent = 'Choose an option first.';
    err.hidden = false;
    return;
  }
  err.hidden = true;
  const label = btn.textContent;
  btn.disabled = true;
  btn.textContent = 'Adding…';
  try {
    const root = window.Shopify?.routes?.root || '/';
    const res = await fetch(`${root}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] }),
    });
    if (!res.ok) throw new Error('add failed');
    const cart = await (await fetch(`${root}cart.js`)).json();
    document.dispatchEvent(new CartAddEvent({}, 'pd-upsell', { source: 'pd-upsell', itemCount: cart.item_count }));
  } catch (e) {
    btn.disabled = false;
    btn.textContent = label;
    err.textContent = 'Could not add this item. Please try again.';
    err.hidden = false;
  }
});

// Pawdusk: removing the main product of a kit keeps the other kit items in the cart as normal items (normal price),
// instead of Shopify removing all nested kit lines together with their parent.
document.addEventListener('click', async (event) => {
  const btn = event.target.closest('.cart-items__remove');
  if (!btn) return;
  const row = btn.closest('tr[data-key]');
  if (!row) return;
  const key = row.dataset.key;
  const children = [...document.querySelectorAll(`tr[data-parent-key="${CSS.escape(key)}"]`)];
  if (!children.length) return; // not a kit parent: let the theme handle it
  event.preventDefault();
  event.stopImmediatePropagation();
  row.classList.add('removing');
  const root = window.Shopify?.routes?.root || '/';
  const keep = children.map((r) => ({ id: Number(r.dataset.variantId), quantity: Number(r.dataset.qty) || 1 }));
  try {
    await fetch(`${root}cart/change.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 }),
    });
    await fetch(`${root}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: keep }),
    });
  } finally {
    const cart = await (await fetch(`${root}cart.js`)).json();
    if (location.pathname.replace(/\/$/, '').endsWith('/cart')) {
      location.reload();
    } else {
      document.dispatchEvent(new CartAddEvent({}, 'pd-kit-split', { source: 'pd-kit-split', itemCount: cart.item_count }));
    }
  }
}, true);

// Pawdusk: choosing a colour/size in "Complete the walk" shows that variant's photo and clears the error.
document.addEventListener('change', (event) => {
  const select = event.target.closest('.pd-up__select');
  if (!select) return;
  const item = select.closest('.pd-up__item');
  const err = item.querySelector('.pd-up__err');
  if (err && select.value) err.hidden = true;
  const img = item.querySelector('.pd-up__img img');
  if (!img) return;
  if (!img.dataset.pdOrig) img.dataset.pdOrig = img.currentSrc || img.src;
  const src = select.selectedOptions[0]?.dataset.img || img.dataset.pdOrig;
  img.removeAttribute('srcset');
  img.src = src;
});

// Pawdusk: Bundlex loads kit photos at 64px, which looks soft at our larger size.
// Give the browser a srcset so it picks a size close to the real display size on every screen (less downscaling = sharper).
const pdSharpen = () => {
  document.querySelectorAll('img.bx-offer-image').forEach((img) => {
    if (img.dataset.pdSharp) return;
    const m = img.src.match(/^(.*?)([?&])width=\d+(&height=\d+)?/);
    if (!m) return;
    const base = img.src.replace(/([?&])width=\d+/, '$1width=W').replace(/([?&])height=\d+/, '$1height=W');
    img.dataset.pdSharp = '1';
    img.srcset = [96, 128, 180, 260, 360].map((w) => `${base.replace(/W/g, w)} ${w}w`).join(', ');
    img.sizes = '(min-width: 750px) 84px, 86px';
    img.src = base.replace(/W/g, 260);
  });
};
new MutationObserver((list) => {
  list.forEach((m) => { if (m.type === 'attributes' && m.target.matches?.('img.bx-offer-image') && !/width=(96|128|180|260|360)\b/.test(m.target.src)) delete m.target.dataset.pdSharp; });
  pdSharpen();
}).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['src'] });
pdSharpen();

// Bundlex: the single-product offer (key 0) is hidden; tapping the active kit again falls back to it
document.addEventListener('click', (e) => {
  const kit = e.target.closest?.('.bx-widget .bx-offer-wrap.js-bx-offer:not([data-offer-key="0"])');
  if (!kit || !kit.classList.contains('bx-active')) return;
  if (e.target.closest('select, option, .bx-offer-variants-wrap, .bx-variants, .bx-extra, [class*="bx-cross"]')) return;
  const single = kit.closest('.bx-widget').querySelector('.bx-offer-wrap[data-offer-key="0"]');
  if (!single) return;
  e.preventDefault(); e.stopImmediatePropagation();
  single.click();
}, true);

// Bundlex: keep the hidden single-product offer (key 0) in sync with the size/colour picker,
// otherwise "Add to cart" adds Bundlex's stale variant (seen: picked M, cart got S).
const pdSyncSingleOffer = () => {
  const single = document.querySelector('.bx-widget .bx-offer-wrap[data-offer-key="0"]');
  if (!single) return;
  const picked = [...document.querySelectorAll('variant-picker fieldset')].map((fs) => fs.querySelector('input[type=radio]:checked')?.value);
  single.querySelectorAll('select.js-bx-variant-select').forEach((sel, i) => {
    const want = picked[i];
    if (!want || sel.value === want || ![...sel.options].some((o) => o.value === want || o.text === want)) return;
    sel.value = [...sel.options].find((o) => o.value === want || o.text === want).value;
    sel.dispatchEvent(new Event('change', {bubbles: true}));
  });
};
document.addEventListener('change', (e) => { if (e.target.closest?.('variant-picker')) setTimeout(pdSyncSingleOffer, 250); });
new MutationObserver(() => { if (document.querySelector('.bx-widget') && !window.__pdSynced) { window.__pdSynced = 1; pdSyncSingleOffer(); } }).observe(document.documentElement, {childList: true, subtree: true});
